import { Component, OnDestroy, OnInit } from '@angular/core';
import { EMAIL_REG_EXP } from '@root/app.config';
import { SaveSessionBlindsService } from '@core/services/save-session-blinds/save-session-blinds.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { EngineService } from '@core/services/engine/engine.service';
import { ModalService } from '@core/services/modal/modal.service';

@Component({
	selector: 'app-save-work-email-modal',
	templateUrl: './save-work-email-modal.component.html',
	styleUrls: ['./save-work-email-modal.component.scss', './save-work-email-modal.responsive.scss'],
})
export class SaveWorkEmailModalComponent implements OnInit, OnDestroy {
	static readonly ID = crypto.randomUUID();

	submitted: boolean;
	saving: boolean;
	emailSent: boolean;
	form = this.fb.group({
		email: ['', [Validators.required, Validators.pattern(EMAIL_REG_EXP)]],
	});

	get f() {
		return this.form.controls;
	}

	constructor(
		private fb: UntypedFormBuilder,
		private matDialog: MatDialog,
		private engineService: EngineService,
		private saveSessionBlind: SaveSessionBlindsService,
		private modalService: ModalService,
		public dialogRef: MatDialogRef<SaveWorkEmailModalComponent>,
	) {}

	ngOnInit() {
		this.engineService.setGizmoControlVisible(false);
		this.modalService.liftUpModal(this.dialogRef);
	}

	ngOnDestroy() {
		this.engineService.setGizmoControlVisible(true);
	}

	onSubmit(): void {
		this.submitted = true;

		if (this.form.valid) {
			this.saving = true;
			this.dialogRef.disableClose = true;

			this.saveSessionBlind.putSaveBlindsPromise(this.form.value.email).then(() => {
				this.dialogRef.disableClose = false;
				this.saving = false;
				this.emailSent = true;
			});
		}
	}

	close(): void {
		this.dialogRef.close();
	}
}
